// src/constants/studio.ts
import { MessageCircle, Camera, Gift } from "lucide-react";

export interface TabConfig {
  id: string;
  label: string;
  icon: any;
  description: string;
}

export const STUDIO_TABS: TabConfig[] = [
  {
    id: "style",
    label: "Style",
    icon: MessageCircle,
    description: "Choose your style",
  },
  {
    id: "message",
    label: "Message",
    icon: MessageCircle,
    description: "Write your heartfelt message",
  },
  {
    id: "photo",
    label: "Photo",
    icon: Camera,
    description: "Add a personal photo",
  },
  {
    id: "bouquet",
    label: "Bouquet",
    icon: Gift,
    description: "Customize your digital bouquet",
  },
];

export const PAYMENT_AMOUNT = 1000;
export const MAX_BOUQUET_ITEMS = 50;
export const MAX_IMAGE_SIZE = 5 * 1024 * 1024; // 5MB
export const SUCCESS_MESSAGE_DURATION = 3000;
export const DEBOUNCE_DELAY = 300;
